import i18n from "@/i18n";

export default [
  { id: "only_once", name: i18n.t("integrations.campaign.attribute.only_once") },
  { id: "instant_checkout_only", name: i18n.t("integrations.campaign.attribute.instant_checkout_only") },
  { id: "mailing_list", name: i18n.t("integrations.campaign.attribute.mailing_list") }
];
